import React from 'react'

import Reward from '../components/Reward'
import styles from '../components/Reward/Reward.scss'

const renderRewards = (
  rewards,
  renderUntilIndex = rewards.length,
  isNewVouchersOffersEnabled,
  hideElement = false,
  style = styles.container,
  RewardTag = 'li',
): React.ReactElement =>
  rewards
    .slice(0, renderUntilIndex)
    .map(
      ({
        activeOfferExpiresAt,
        amountFormatted,
        headline,
        isOfferActive,
        isValidFromEnable,
        offerKey,
        offerPropositionId,
        path,
        personalizedExpireDateFormatted,
        srcImage,
        startDateTimeFormatted,
        typeCat,
        validFromLabel,
        isValidUntilEnable,
        type,
        logo,
        dateInfoText,
      }) => {
        return (
          <Reward
            Tag={RewardTag}
            activeOfferExpiresAt={activeOfferExpiresAt}
            amountFormatted={amountFormatted}
            headline={headline || ''}
            isOfferActive={isOfferActive}
            isValidFromEnable={isValidFromEnable}
            isValidUntilEnable={isValidUntilEnable}
            key={offerKey}
            offerKey={offerKey}
            pathWithQueries={`${path}.html?offerPropositionId=${offerPropositionId}`}
            offerPropositionId={offerPropositionId}
            personalizedExpireDateFormatted={personalizedExpireDateFormatted}
            srcImage={srcImage}
            startDateTimeFormatted={startDateTimeFormatted}
            typeCat={typeCat}
            validFromLabel={validFromLabel}
            type={type}
            logo={logo}
            className={style}
            dateInfoText={dateInfoText}
            isNewVouchersOffersEnabled={isNewVouchersOffersEnabled}
            hideElement={hideElement}
          />
        )
      },
    )

export default renderRewards
